require('../../modules/es6.object.keys');
module.exports = require('../../modules/_core').Object.keys;


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/library/fn/object/keys.js
 ** module id = 324
 ** module chunks = 0
 **/